import BaseModel from '../../core/baseModel';
import { get as t } from '../../../home24/core/translation';

export default BaseModel.extend({
  defaults: {
    orderId: null,
    errorCount: 0,
    articles: [],
    comment: ''
  },

  clear: function() {
    this.set({
      orderId: null,
      errorCount: 0,
      articles: [],
      comment: ''
    });
  },

  /**
   * Method validates current model and returns true if valid, in the other case returns localized
   * error message
   * @return {bool|String}
   */
  validate: function() {
    var retVal = true;

    if (this.get('errorCount') > 0) {
      retVal = t('orderItem.quantityIsRequired.message');
    } else if (!this.get('orderId') || !this.get('articles').length) {
      retVal = t('orderItem.atleastOneIsRequired.message');
    }

    return retVal;
  }
});



/** WEBPACK FOOTER **
 ** ./legacy/home24-desktop/pages/fttc2/Step1Model.js
 **/